import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function SubscriptionStatus() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [listingCount, setListingCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const [subRes, countRes] = await Promise.all([
          fetch('/api/subscriptions/status', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          }),
          fetch('/api/subscriptions/listing-count', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          })
        ]);

        if (subRes.ok) setStatus(await subRes.json());
        if (countRes.ok) setListingCount(await countRes.json());
      } catch (err) {
        console.error('Failed to fetch subscription status:', err);
      } finally {
        setLoading(false);
      }
    };

    if (user) fetchStatus();
  }, [user]);

  if (loading) return <div style={{ padding: '12px', color: 'var(--text-soft)' }}>Loading...</div>;
  if (!status || !listingCount) return null;

  const isPremium = status.planType === 'premium' && status.hasSubscription;
  const isFree = status.planType === 'free' || !status.hasSubscription;

  return (
    <div style={{
      padding: '16px',
      borderRadius: 12,
      background: isPremium ? 'rgba(255, 193, 7, 0.1)' : 'rgba(0, 0, 0, 0.02)',
      border: `1px solid ${isPremium ? 'rgba(255, 193, 7, 0.3)' : 'var(--border)'}`,
      marginBottom: '16px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 }}>
            {isPremium ? '⭐ Premium' : '🆓 Free Tier'}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-soft)' }}>
            {isPremium ? 'Unlimited listings' : 'Up to 3 listings'}
          </div>
        </div>
        {isFree && (
          <button
            onClick={() => window.location.href = '/dashboard/subscription'}
            style={{
              padding: '6px 12px',
              background: 'var(--cherry)',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Upgrade
          </button>
        )}
      </div>

      <div style={{ fontSize: 12, color: 'var(--text-soft)' }}>
        Listings: <strong>{listingCount.currentCount}</strong> {isFree ? `/ ${listingCount.limit}` : '/ ∞'}
      </div>

      {isFree && listingCount.canListMore === false && (
        <div style={{
          marginTop: '12px',
          padding: '8px',
          background: 'rgba(244, 67, 54, 0.1)',
          border: '1px solid rgba(244, 67, 54, 0.3)',
          borderRadius: 6,
          fontSize: 12,
          color: '#d32f2f',
          fontWeight: 500
        }}>
          ⚠️ You've reached your listing limit. Upgrade to Premium for unlimited listings.
        </div>
      )}

      {isPremium && status.subscription?.current_period_end && (
        <div style={{ marginTop: '8px', fontSize: 12, color: 'var(--text-soft)' }}>
          Next billing: {new Date(status.subscription.current_period_end).toLocaleDateString()}
        </div>
      )}
    </div>
  );
}
